// CustomModal.tsx
import React from 'react';
import { Modal, Box, Button } from '@mui/material';
import CustomizedSteppers from '../CustomizedSteppers/CustomizedSteppers';

interface CustomModalProps {
  open: boolean;
  handleClose: () => void;
  showAlert: (message: string, severity: 'success' | 'error') => void;
}

const CustomModal: React.FC<CustomModalProps> = ({ open, handleClose, showAlert }) => (
  <Modal open={open} onClose={handleClose}>
    <Box
      sx={{
        position: 'absolute',
        top: '45%',
        left:{xs:'45%', md:'50%'},
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '8px',
        marginRight:{xs:'100%'} 
      }}
    >
      <CustomizedSteppers handleClose={handleClose} showAlert={showAlert} />
      <Box sx={{ textAlign: "center" }}>
        <Button onClick={handleClose} sx={{ mt: 3, borderRadius: '15px' }} variant="contained" color="error">
          Cerrar
        </Button>
      </Box>
    </Box>
  </Modal>
);

export default CustomModal;
